import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../Profile.module.css';

interface TagListProps {
  items: string[];
}

const TagList: React.FC<TagListProps> = ({ items }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.tagContainer}>
      {items.map((item, index) => (
        <div key={index} className={styles.tag}>
          {t(item)}
        </div>
      ))}
    </div>
  );
};

export default TagList;